/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomFieldValueRead } from './CustomFieldValueRead';
import {
  CustomFieldValueReadFromJSON,
  CustomFieldValueReadFromJSONTyped,
  CustomFieldValueReadToJSON,
} from './CustomFieldValueRead';
import type { UseCaseName } from './UseCaseName';
import { UseCaseNameFromJSON, UseCaseNameFromJSONTyped, UseCaseNameToJSON } from './UseCaseName';
import type { DatasetPipelineShallow } from './DatasetPipelineShallow';
import {
  DatasetPipelineShallowFromJSON,
  DatasetPipelineShallowFromJSONTyped,
  DatasetPipelineShallowToJSON,
} from './DatasetPipelineShallow';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface RichAiModel
 */
export interface RichAiModel {
  /**
   *
   * @type {number}
   * @memberof RichAiModel
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof RichAiModel
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof RichAiModel
   */
  technicalOwner: string;
  /**
   *
   * @type {string}
   * @memberof RichAiModel
   */
  technicalInfo: string;
  /**
   *
   * @type {string}
   * @memberof RichAiModel
   */
  datasetInfo: string;
  /**
   *
   * @type {UseCaseName}
   * @memberof RichAiModel
   */
  readonly useCase: UseCaseName;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof RichAiModel
   */
  taskType?: TaskTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof RichAiModel
   */
  liveFrom?: Date | null;
  /**
   *
   * @type {Date}
   * @memberof RichAiModel
   */
  decomissionedOn?: Date | null;
  /**
   *
   * @type {string}
   * @memberof RichAiModel
   */
  updateUser?: string;
  /**
   *
   * @type {Date}
   * @memberof RichAiModel
   */
  timestamp?: Date;
  /**
   *
   * @type {Date}
   * @memberof RichAiModel
   */
  lastValidation: Date;
  /**
   *
   * @type {Array<DatasetPipelineShallow>}
   * @memberof RichAiModel
   */
  readonly datasetPipelines: Array<DatasetPipelineShallow>;
  /**
   *
   * @type {string}
   * @memberof RichAiModel
   */
  readonly hasQuestionnaire: string;
  /**
   *
   * @type {string}
   * @memberof RichAiModel
   */
  readonly latestAssessmentStatus: string;
  /**
   *
   * @type {string}
   * @memberof RichAiModel
   */
  readonly latestAssessment: string;
  /**
   *
   * @type {string}
   * @memberof RichAiModel
   */
  readonly status: string;
  /**
   *
   * @type {Array<CustomFieldValueRead>}
   * @memberof RichAiModel
   */
  readonly customFieldValues: Array<CustomFieldValueRead>;
}

/**
 * Check if a given object implements the RichAiModel interface.
 */
export function instanceOfRichAiModel(value: object): value is RichAiModel {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('technicalOwner' in value) || value['technicalOwner'] === undefined) return false;
  if (!('technicalInfo' in value) || value['technicalInfo'] === undefined) return false;
  if (!('datasetInfo' in value) || value['datasetInfo'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('lastValidation' in value) || value['lastValidation'] === undefined) return false;
  if (!('datasetPipelines' in value) || value['datasetPipelines'] === undefined) return false;
  if (!('hasQuestionnaire' in value) || value['hasQuestionnaire'] === undefined) return false;
  if (!('latestAssessmentStatus' in value) || value['latestAssessmentStatus'] === undefined) return false;
  if (!('latestAssessment' in value) || value['latestAssessment'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('customFieldValues' in value) || value['customFieldValues'] === undefined) return false;
  return true;
}

export function RichAiModelFromJSON(json: any): RichAiModel {
  return RichAiModelFromJSONTyped(json, false);
}

export function RichAiModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RichAiModel {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    technicalOwner: json['technical_owner'],
    technicalInfo: json['technical_info'],
    datasetInfo: json['dataset_info'],
    useCase: UseCaseNameFromJSON(json['use_case']),
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    liveFrom: json['live_from'] == null ? undefined : new Date(json['live_from']),
    decomissionedOn: json['decomissioned_on'] == null ? undefined : new Date(json['decomissioned_on']),
    updateUser: json['update_user'] == null ? undefined : json['update_user'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    lastValidation: new Date(json['last_validation']),
    datasetPipelines: (json['dataset_pipelines'] as Array<any>).map(DatasetPipelineShallowFromJSON),
    hasQuestionnaire: json['has_questionnaire'],
    latestAssessmentStatus: json['latest_assessment_status'],
    latestAssessment: json['latest_assessment'],
    status: json['status'],
    customFieldValues: (json['custom_field_values'] as Array<any>).map(CustomFieldValueReadFromJSON),
  };
}

export function RichAiModelToJSON(
  value?: Omit<
    RichAiModel,
    | 'id'
    | 'useCase'
    | 'datasetPipelines'
    | 'hasQuestionnaire'
    | 'latestAssessmentStatus'
    | 'latestAssessment'
    | 'status'
    | 'customFieldValues'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    technical_owner: value['technicalOwner'],
    technical_info: value['technicalInfo'],
    dataset_info: value['datasetInfo'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
    live_from: value['liveFrom'] == null ? undefined : (value['liveFrom'] as any).toISOString().substring(0, 10),
    decomissioned_on:
      value['decomissionedOn'] == null ? undefined : (value['decomissionedOn'] as any).toISOString().substring(0, 10),
    update_user: value['updateUser'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    last_validation: value['lastValidation'].toISOString().substring(0, 10),
  };
}
